import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryClusterPageService_MetadataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_cluster_page/v1/service.grpc.lazy';
import {RouterErrorHandler, useRecentFullUrl} from '@aboutyou/router';
import React from 'react';
import {useEnsureRedirectData} from '../../../shared-deprecated/useEnsureRedirectData';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useStoryClusterIdFromUrl} from '../useStoryClusterIdFromUrl';
import {MetaView} from './MetaView';

export const Meta = () => {
  return (
    <DataFetcher
      request={useMetaRequest()}
      Error={RouterErrorHandler}
      View={MetaView}
    />
  );
};

const useMetaRequest = () => {
  const ensureRedirectData = useEnsureRedirectData();
  const targetGroup = useTargetGroupIdentifier();
  const fullUrl = useRecentFullUrl();
  const storyClusterId = useStoryClusterIdFromUrl();

  return useGrpcRequest(
    StoryClusterPageService_MetadataLazy,
    {
      targetGroup,
      storyClusterId: storyClusterId!,
      url: fullUrl,
    },
    {
      validateData: ensureRedirectData,
    },
  );
};
